require('/cloud/source_code/node_modules/_@alife_cnc-upload-progress@1.0.2@@alife/cnc-upload-progress/es/style.js');
import "cn-next/es/config-provider/style";
import _ConfigProvider from "cn-next/es/config-provider";
import { componentName } from "./const";
import View from "./view";

var Index = _ConfigProvider.config(View, {
  componentName: componentName
});

Index.displayName = componentName;
export default Index;